module.exports = __webpack_public_path__ + "static/media/icn-stby-lists.4e01e773.svg";